import Service				from "./../../Libs/Service";
import _					from "lodash";

import { Server } 			from "./Server";
import {Version} from "./Version";

let Localization = new Service({

	Name: "Localization",

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		},

		"Settings Selected": function(settings) {

			//this.updateParams();

		},

		"IFrame Data:ChangeLocalizationMessage": function(data) {

			let locale = data?.locale || (Array.isArray(data) ? data[0] : null);
			let codename = data?.codename || (Array.isArray(data) ? data[1] : null);
			let text = data?.text !== undefined ? data.text : (Array.isArray(data) ? data[2] : null);
			let versionId = data?.versionId || Version.SelectedVersion?.id;

			if (versionId && locale && codename && text !== undefined && text !== null) {

				this.changeLocalizationMessage(versionId, locale, codename, text);

			}

		},

		"Selected Version Localization Changed": function(versionId, locale, localizationCodename) {

			Broadcast.call("Send To iFrame", [{
				Localization: {
					[locale]: {
						[localizationCodename]: this.LocalizationByVersionByLocaleByCodename[versionId]?.[locale]?.[localizationCodename]
					}
				}
			}]);

		},

	},

	Actions: {

		//serverId - нода, с которой пришли данные
		"Localization": function(localizationByVersion, data, size, serverId) {

			_.each(localizationByVersion, (versionLocalizations, versionId) => {

				_.each(versionLocalizations, (localeLocalizations, locale) => {

					_.each(localeLocalizations, (newLocalization, localizationCodename) => {

						this.setLocalization(parseInt(versionId), locale, localizationCodename, newLocalization, serverId);

					});

				});

				//Если установлен этот маркер - значит отправляются все ассеты указанной версии (создание новой версии)
				if (data.LocalizationVersionId) {

					Broadcast.call(`Version Localization Loaded`, [versionId]);
					Broadcast.call(`Version Localization Loaded:${versionId}`);
					if ((Version.SelectedVersion?.baseVersionId || Version.SelectedVersion?.id) === parseInt(versionId)) Broadcast.call(`Selected Version Localization Loaded`);

				}

			});

			//Если установлен этот маркер - значит это первоначальное получение данных о только что впервые открытом креативе (все ассеты всех версий креатива загружаются)
			if (data.LocalizationCreativeId) Broadcast.call(`Creative Localization Loaded`, [data.LocalizationCreativeId]);
			if (data.LocalizationVersionId) Broadcast.call(`Version Localization Loaded`, [data.LocalizationVersionId]);

			//Помечаем этим маркером первоначальную загрузку локализации первого наблюдаемого креатива
			this.loaded = true;

			//this.updateLocalization(texts);

		},

		"LocalizationOriginal": function(localizationOriginalByVersions, data, size, serverId) {

			let localizationOriginalByVersion = this.getServerMap(this.LocalizationOriginalByVersionByServer, serverId || this.NodeServerId),
				localizationOriginalByVersionByLocaleByCodename = this.getServerMap(this.LocalizationOriginalByVersionByLocaleByCodenameByServer, serverId || this.NodeServerId);

			_.each(localizationOriginalByVersions, (versionLocalizationsOriginal, versionId) => {

				localizationOriginalByVersion[versionId] = {};
				localizationOriginalByVersionByLocaleByCodename[versionId] = {};

				_.each(versionLocalizationsOriginal, (localeLocalizationsOriginal, locale) => {

					_.each(localeLocalizationsOriginal, (newLocalizationOriginal, localizationCodename) => {

						this.setLocalizationOriginal(parseInt(versionId), locale, localizationCodename, newLocalizationOriginal, serverId);

					});

				});

				//Если установлен этот маркер - значит отправляются все original ассеты указанной версии (обновление креатива из репозитория)
				if (data.LocalizationVersionId) {

					Broadcast.call(`Version Localization Original Loaded`, [versionId]);
					Broadcast.call(`Version Localization Original Loaded:${versionId}`);
					if ((Version.SelectedVersion?.baseVersionId || Version.SelectedVersion?.id) === parseInt(versionId)) Broadcast.call(`Selected Version Localization Original Loaded`);

				}

			});

			//Если установлен этот маркер - значит это первоначальное получение данных о только что впервые открытом креативе (все ассеты всех версий креатива загружаются)
			if (data.LocalizationCreativeId) {

				Broadcast.call(`Creative Localization Original Loaded`, [data.LocalizationCreativeId]);

			}

		},

		"ChangedLocalization": function(changedLocalizationData, data, size, serverId) {

			let localizationByVersionByLocaleByCodename = this.getServerMap(this.LocalizationByVersionByLocaleByCodenameByServer, serverId || this.NodeServerId);

			_.each(changedLocalizationData, changedLocalizationData => {

				let oldLocalization = localizationByVersionByLocaleByCodename[changedLocalizationData.versionId]?.[changedLocalizationData.locale]?.[changedLocalizationData.localizationCodename];

				this.setLocalization(changedLocalizationData.versionId, changedLocalizationData.locale, changedLocalizationData.localizationCodename, changedLocalizationData.localization, serverId);

				this.detectLocalizationChanges(changedLocalizationData.versionId, oldLocalization, changedLocalizationData.localization);

			});

		}

	},

	init() {

		//Карты данных по нодам кластера: у каждой ноды своя БД, и id версий и текстов
		//на разных нодах совпадают, поэтому карты разделены по нодам (Client/Libs/Service.js, getServerMap)
		this.LocalizationByServer = {};
		this.LocalizationByVersionByServer = {};
		this.LocalizationByVersionByLocaleByCodenameByServer = {};
		this.LocalizationOriginalByServer = {};
		this.LocalizationOriginalByVersionByServer = {};
		this.LocalizationOriginalByVersionByLocaleByCodenameByServer = {};

		this.loaded = false;

		// Активные карты - карты рабочей ноды
		this.useServer(0);

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (Localization[id]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		this.Localization = this.getServerMap(this.LocalizationByServer, serverId);
		this.LocalizationByVersion = this.getServerMap(this.LocalizationByVersionByServer, serverId);
		this.LocalizationByVersionByLocaleByCodename = this.getServerMap(this.LocalizationByVersionByLocaleByCodenameByServer, serverId);

		this.LocalizationOriginal = this.getServerMap(this.LocalizationOriginalByServer, serverId);
		this.LocalizationOriginalByVersion = this.getServerMap(this.LocalizationOriginalByVersionByServer, serverId);
		this.LocalizationOriginalByVersionByLocaleByCodename = this.getServerMap(this.LocalizationOriginalByVersionByLocaleByCodenameByServer, serverId);

	},

	// serverId - нода, с которой пришли данные: пишем в карты этой ноды
	setLocalizationOriginal(versionId, locale, localizationCodename, localizationOriginal, serverId) {

		serverId = serverId || this.NodeServerId;

		let localizationOriginalMap = this.getServerMap(this.LocalizationOriginalByServer, serverId),
			localizationOriginalByVersion = this.getServerMap(this.LocalizationOriginalByVersionByServer, serverId),
			localizationOriginalByVersionByLocaleByCodename = this.getServerMap(this.LocalizationOriginalByVersionByLocaleByCodenameByServer, serverId);

		localizationOriginalMap[localizationOriginal.id] = localizationOriginal;

		if (!localizationOriginalByVersion[localizationOriginal['version_id']]) localizationOriginalByVersion[localizationOriginal['version_id']] = {};
		localizationOriginalByVersion[localizationOriginal['version_id']][localizationOriginal.id] = localizationOriginal;

		if (!localizationOriginalByVersionByLocaleByCodename[localizationOriginal['version_id']]) localizationOriginalByVersionByLocaleByCodename[localizationOriginal['version_id']] = {};
		if (!localizationOriginalByVersionByLocaleByCodename[localizationOriginal['version_id']][localizationOriginal['locale']]) localizationOriginalByVersionByLocaleByCodename[localizationOriginal['version_id']][localizationOriginal['locale']] = {};
		localizationOriginalByVersionByLocaleByCodename[localizationOriginal['version_id']][localizationOriginal['locale']][localizationOriginal.codename] = localizationOriginal;

	},

	// serverId - нода, с которой пришли данные: пишем в карты этой ноды
	setLocalization(versionId, locale, localizationCodename, localization, serverId) {

		serverId = serverId || this.NodeServerId;

		let localizationMap = this.getServerMap(this.LocalizationByServer, serverId),
			localizationByVersion = this.getServerMap(this.LocalizationByVersionByServer, serverId),
			localizationByVersionByLocaleByCodename = this.getServerMap(this.LocalizationByVersionByLocaleByCodenameByServer, serverId);

		let oldLocalization = localizationByVersionByLocaleByCodename[versionId]?.[locale]?.[localizationCodename];

		if (localization) {

			localizationMap[localization.id] = localization;

			if (!localizationByVersion[localization['version_id']]) localizationByVersion[localization['version_id']] = {};
			localizationByVersion[localization['version_id']][localization.id] = localization;

			if (!localizationByVersionByLocaleByCodename[localization['version_id']]) localizationByVersionByLocaleByCodename[localization['version_id']] = {};
			if (!localizationByVersionByLocaleByCodename[localization['version_id']][localization['locale']]) localizationByVersionByLocaleByCodename[localization['version_id']][localization['locale']] = {};
			localizationByVersionByLocaleByCodename[localization['version_id']][localization['locale']][localization.codename] = localization;

		} else {

			if (oldLocalization) {

				delete localizationMap[oldLocalization.id];
				if (localizationByVersion[oldLocalization['version_id']]) delete localizationByVersion[oldLocalization['version_id']][oldLocalization.id];
				if (localizationByVersionByLocaleByCodename[oldLocalization['version_id']]?.[oldLocalization.locale]) delete localizationByVersionByLocaleByCodename[oldLocalization['version_id']][oldLocalization.locale][oldLocalization.codename];

			}

		}

	},

	//Определяем какие конкретно изменения произошли
	detectLocalizationChanges(versionId, oldLocalization, newLocalization) {

		//Если такой объект изменений локализации уже был на клиенте
		if (oldLocalization) {

			if (newLocalization) {

				if (newLocalization['version_id'] === Version.SelectedVersion?.id) {

					Broadcast.call(`Selected Version Localization Changed`, [newLocalization['version_id'], newLocalization['locale'], newLocalization.codename]);
					Broadcast.call(`Selected Version Localization Changed:${newLocalization.codename}`, [newLocalization['version_id'], newLocalization['locale'], newLocalization.codename]);

				} else {

					Broadcast.call(`Localization Changed`, [newLocalization['version_id'], newLocalization['locale'], newLocalization.codename]);
					Broadcast.call(`Localization Changed:${versionId}:${newLocalization.codename}`, [newLocalization['version_id'], newLocalization['locale'], newLocalization.codename]);

				}

			}

			//Если изменения ессета удалили (возможно reset)
			else {

				//Если это локализация текущей просматриваемой пользователем версии креатива
				if (oldLocalization['version_id'] === Version.SelectedVersion?.id) {

					//Если локализация была в json файле настроек
					if (this.LocalizationOriginalByVersionByLocaleByCodename[Version.getVersion(oldLocalization['version_id'])?.baseVersionId]?.[oldLocalization.locale]?.[oldLocalization.codename]) {

						Broadcast.call(`Selected Version Localization Restored`, [oldLocalization['version_id'], oldLocalization.codename]);
						Broadcast.call(`Selected Version Localization Restored:${oldLocalization.codename}`, [oldLocalization['version_id'], oldLocalization.codename]);

					} else {

						Broadcast.call(`Selected Version Localization Deleted`, [oldLocalization['version_id'], oldLocalization.codename]);
						Broadcast.call(`Selected Version Localization Deleted:${oldLocalization.codename}`, [oldLocalization['version_id'], oldLocalization.codename]);

					}

				} else {

					//Если локализация была в json файле настроек
					if (this.LocalizationOriginalByVersionByLocaleByCodename[Version.getVersion(oldLocalization['version_id'])?.baseVersionId]?.[oldLocalization.locale]?.[oldLocalization.codename]) {

						Broadcast.call(`Localization Restored`, [oldLocalization]);
						Broadcast.call(`Localization Restored:${versionId}:${oldLocalization.codename}`, [oldLocalization]);

					} else {

						Broadcast.call(`Localization Deleted`, [oldLocalization]);
						Broadcast.call(`Localization Deleted:${versionId}:${oldLocalization.codename}`, [oldLocalization]);

					}

				}

			}

		}

		//Если такого объекта изменений локализации ещё не было на клиенте
		else {

			//Если в новых пришедших данных есть объект изменённых данных локализации
			if (newLocalization) {

				//Если это локализация текущей просматриваемой пользователем версии креатива
				if (newLocalization['version_id'] === Version.SelectedVersion?.id) {

					Broadcast.call(`Selected Version Localization Changed`, [newLocalization['version_id'], newLocalization['locale'], newLocalization.codename]);
					Broadcast.call(`Selected Version Localization Changed:${newLocalization.codename}`, [newLocalization['version_id'], newLocalization['locale'], newLocalization.codename]);

				} else {

					Broadcast.call(`Localization Changed`, [newLocalization['version_id'], newLocalization['locale'], newLocalization.codename]);
					Broadcast.call(`Localization Changed:${versionId}:${newLocalization.codename}`, [newLocalization['version_id'], newLocalization['locale'], newLocalization.codename]);

				}

			}

			//Если изменения локализации удалили (возможно reset)
			else {

				//Тут можно ничего не делаеть. Изменений локализации и так не было, но пришло сообщение что их удалили

			}

		}

	},

	getVersionLocalization(version) {

		if (!version) return {};

		let localization = {};

		_.each(this.LocalizationOriginalByVersion[version.baseVersionId || version.id], text => {

			if (!localization[text.locale]) localization[text.locale] = {};

			localization[text.locale][text.codename] = _.cloneDeep(text);

		});

		_.each(this.LocalizationByVersion[version.id], text => {

			if (!localization[text.locale]) localization[text.locale] = {};

			localization[text.locale][text.codename] = _.merge(localization[text.locale][text.codename] || {}, text);

		});

		let endCardVersion = Renderer.getEndCardVersion(Creative.getCreative(version['creative_id']), version);

		if (endCardVersion) _.merge(localization, this.getVersionLocalization(endCardVersion));

		return localization;

	},

	cleanVersionLocalization(localization) {

		_.each(localization, localeLocalization => {

			_.each(localeLocalization, (localization, localizationCodename) => {

				localeLocalization[localizationCodename] = this.getMergedLocalization(localization)

			});

		});

		return localization;

	},

	isLocalizationStyleChanged(version, locale, localizationCodename, styleName) {

		if (!version) return false;

		if (!this.LocalizationByVersionByLocaleByCodename[version.id]?.[locale]?.[localizationCodename]?.styles) return false;
		if (!this.LocalizationOriginalByVersionByLocaleByCodename[version.baseVersionId || version.id]?.[locale]?.[localizationCodename]?.styles) return false;

		return this.LocalizationByVersionByLocaleByCodename[version.id][locale][localizationCodename].styles.hasOwnProperty(styleName) && this.LocalizationByVersionByLocaleByCodename[version.id][locale][localizationCodename].styles[styleName] !== this.LocalizationOriginalByVersionByLocaleByCodename[version.baseVersionId || version.id][locale][localizationCodename].styles[styleName];

	},

	isLocalizationStylesChanged(version, locale, localizationCodename) {

		if (!version) return false;

		if (!this.LocalizationByVersionByLocaleByCodename[version.id]?.[locale]?.[localizationCodename]?.styles) return false;
		if (!this.LocalizationOriginalByVersionByLocaleByCodename[version.baseVersionId || version.id]?.[locale]?.[localizationCodename]?.styles) return false;

		let result = false;

		let styleNames = _.uniq(_.keys(this.LocalizationByVersionByLocaleByCodename[version.id][locale][localizationCodename].styles).concat(_.keys(this.LocalizationOriginalByVersionByLocaleByCodename[version.baseVersionId || version.id][locale][localizationCodename].styles)));

		_.each(styleNames, styleName => {

			if (this.isLocalizationStyleChanged(version, locale, localizationCodename, styleName)) result = true;

		});

		return result;

	},

	isLocalizationMessageChanged(version, locale, localizationCodename) {

		if (!version) return false;

		if (!this.LocalizationByVersionByLocaleByCodename[version.id]?.[locale]?.[localizationCodename]) return false;
		if (!this.LocalizationOriginalByVersionByLocaleByCodename[version.baseVersionId || version.id]?.[locale]?.[localizationCodename]) return false;

		return this.LocalizationByVersionByLocaleByCodename[version.id][locale][localizationCodename].message !== this.LocalizationOriginalByVersionByLocaleByCodename[version.baseVersionId || version.id][locale][localizationCodename].message;

	},

	isLocalizationHasOrigin(version, locale, localizationCodename) {

		return !!this.LocalizationOriginalByVersionByLocaleByCodename[version.baseVersionId || version.id]?.[locale]?.[localizationCodename];

	},

	getMergedLocalization(localization) {

		return _.extend({text: localization["message"]}, _.cloneDeep(_.omitBy(localization.styles, (v, k) => v === '#deleted#' || k === 'type')));

	},

	changeLocalizationMessage(versionId, locale, codename, text) {

		Server.sendToSocket({
			ChangeLocalizationMessage: {
				versionId,
				locale,
				codename,
				text
			}
		});

	},

	checkLocalizationStyle(styleName, styleValue) {

		if (styleName === 'fontSize' && styleValue <= 0) styleValue = 1;

		let styleProps = Metadata.ElementStylesByCodename[styleName];

		if (styleProps?.type === 'number') styleValue = parseFloat(styleValue);
		if (styleProps?.type === 'boolean') styleValue = styleValue === true || styleValue === 'true';

		return styleValue;

	}

});

window.Localization = Localization;

export { Localization }

